import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PlanContainerLocationCount } from "../../domain/models/plan-container-location-count";
import { MasterPlansRepository, MasterlocationRepository } from "../../repositories";
import { Injectable } from "@angular/core";
import { PlanContainerLocationCountByProduct } from "../../domain/models/plan-container-location-count-by-product";

@Injectable({ providedIn: 'root' })
export class GetLocationCountByProductUseCase implements UseCase<string, PlanContainerLocationCountByProduct>{
  
  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }
  execute(param: string): Observable<PlanContainerLocationCountByProduct> {
   return this.masterPlanRepository.getLocationCountByProduct(param);
  }

}